import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const FloatingActionButtons = () => {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);
  const [chatMessages, setChatMessages] = useState([
    {
      id: 1,
      text: "Hi! Welcome to Dandeli Adventure Resorts! 🌿",
      isBot: true,
      timestamp: new Date()
    },
    {
      id: 2,
      text: "How can I help you today?",
      isBot: true,
      timestamp: new Date()
    }
  ]);

  const quickReplies = [
    "Room Availability",
    "Package Details", 
    "Adventure Activities",
    "Pricing Information",
    "Location & Directions"
  ];

  const handleCallClick = () => {
    window.open('tel:+918277385225', '_self');
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hi! I'm interested in booking a stay at Dandeli Adventure Resorts. Can you please provide me with more information?");
    window.open(`https://wa.me/918277385225?text=${message}`, '_blank');
  };

  const toggleChatbot = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsChatbotOpen(!isChatbotOpen);
  };

  const handleQuickReply = (reply) => {
    const newUserMessage = {
      id: Date.now(),
      text: reply,
      isBot: false,
      timestamp: new Date()
    };

    const botResponse = getBotResponse(reply);
    const newBotMessage = {
      id: Date.now() + 1,
      text: botResponse,
      isBot: true,
      timestamp: new Date()
    };

    setChatMessages(prev => [...prev, newUserMessage, newBotMessage]);
  };

  const getBotResponse = (userMessage) => {
    switch(userMessage) {
      case "Room Availability":
        return "We have various accommodations available! From luxury riverside cottages to cozy forest rooms. Would you like me to connect you with our booking team for real-time availability?";
      case "Package Details":
        return "We offer exciting packages including Adventure Package (₹3,999), Family Special (₹6,499), and Weekend Getaway (₹2,499). Each includes accommodation, meals, and activities!";
      case "Adventure Activities":
        return "Experience thrilling white water rafting, jungle safaris, trekking, rock climbing, and more! All activities are guided by certified professionals for your safety.";
      case "Pricing Information":
        return "Our rooms start from ₹1,499/night. Packages include meals and activities. For detailed pricing and current offers, I'll connect you with our team!";
      case "Location & Directions":
        return "We're located in Dandeli Forest Reserve, Karnataka. Easy access by road from Bangalore (460km) and Goa (120km). Need directions or transport assistance?";
      default:
        return "That's a great question! Let me connect you with our team who can provide detailed information. You can call us or continue on WhatsApp.";
    }
  };

  return (
    <>
      {/* Call Button - Bottom Left */}
      <div className="fixed bottom-20 sm:bottom-6 left-6 z-40">
        <button
          onClick={handleCallClick}
          className="w-12 h-12 sm:w-14 sm:h-14 bg-accent text-accent-foreground rounded-full shadow-organic-lg call-bounce hover:scale-110 transition-organic flex items-center justify-center group"
          aria-label="Call Now"
        >
          <Icon name="Phone" size={20} className="group-hover:animate-pulse" />
        </button>
        <div className="absolute -top-12 left-1/2 transform -translate-x-1/2 bg-text-primary text-white px-3 py-1 rounded-lg text-sm font-caption opacity-0 group-hover:opacity-100 transition-organic">
          Call Now
        </div>
      </div>

      {/* WhatsApp and Chatbot Section - Bottom Right */}
      <div className="fixed bottom-20 sm:bottom-6 right-6 z-40 flex flex-col items-end space-y-4">
        {/* Chatbot */}
        <div className="relative">
          {/* Chatbot Window */}
          {isChatbotOpen && (
            <div className="absolute bottom-16 right-0 w-80 bg-white rounded-2xl shadow-organic-xl border border-border animate-in slide-in-from-bottom-5 duration-300">
              {/* Chatbot Header */}
              <div className="bg-primary text-primary-foreground px-4 py-3 rounded-t-2xl flex items-center justify-between">
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-primary-foreground/20 rounded-full flex items-center justify-center mr-3">
                    <Icon name="MessageCircle" size={16} className="text-primary-foreground" />
                  </div>
                  <div>
                    <h4 className="font-heading font-semibold text-sm">Resort Assistant</h4>
                    <p className="text-xs text-primary-foreground/80">Online now</p>
                  </div>
                </div>
                <button
                  onClick={toggleChatbot}
                  className="w-6 h-6 hover:bg-primary-foreground/20 rounded-full flex items-center justify-center transition-organic"
                >
                  <Icon name="X" size={14} />
                </button>
              </div>

              {/* Chat Messages */}
              <div className="max-h-64 overflow-y-auto p-4 space-y-3">
                {chatMessages?.map((message) => (
                  <div
                    key={message?.id}
                    className={`flex ${message?.isBot ? 'justify-start' : 'justify-end'}`}
                  >
                    <div
                      className={`max-w-[70%] p-3 rounded-xl text-sm font-body ${
                        message?.isBot
                          ? 'bg-muted text-text-primary' :'bg-primary text-primary-foreground'
                      }`}
                    >
                      {message?.text}
                    </div>
                  </div>
                ))}
              </div>

              {/* Quick Replies */}
              <div className="p-4 border-t border-border">
                <div className="grid grid-cols-1 gap-2">
                  {quickReplies?.slice(0, 3)?.map((reply) => (
                    <button
                      key={reply}
                      onClick={() => handleQuickReply(reply)}
                      className="text-left px-3 py-2 text-sm bg-muted hover:bg-primary hover:text-primary-foreground rounded-lg transition-organic font-body"
                    >
                      {reply}
                    </button>
                  ))}
                </div>
                <div className="flex space-x-2 mt-3">
                  <button
                    onClick={handleCallClick}
                    className="flex-1 bg-accent text-accent-foreground px-3 py-2 rounded-lg text-sm font-heading font-medium hover:bg-accent/90 transition-organic flex items-center justify-center"
                  >
                    <Icon name="Phone" size={14} className="mr-1" />
                    Call
                  </button>
                  <button
                    onClick={handleWhatsAppClick}
                    className="flex-1 bg-green-600 text-white px-3 py-2 rounded-lg text-sm font-heading font-medium hover:bg-green-700 transition-organic flex items-center justify-center"
                  >
                    <Icon name="MessageCircle" size={14} className="mr-1" />
                    WhatsApp
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Chatbot Toggle Button */}
          <button
            onClick={toggleChatbot}
            className="w-12 h-12 bg-secondary text-secondary-foreground rounded-full shadow-organic-lg chat-pulse hover:scale-110 transition-organic flex items-center justify-center relative"
            aria-label="Open Chat Assistant"
          >
            <Icon name={isChatbotOpen ? "X" : "MessageCircle"} size={20} />
            {!isChatbotOpen && (
              <div className="absolute -top-1 -right-1 w-3 h-3 bg-success rounded-full animate-pulse"></div>
            )}
          </button>
        </div>

        {/* WhatsApp Button */}
        <button
          onClick={handleWhatsAppClick}
          className="w-12 h-12 sm:w-14 sm:h-14 bg-green-600 text-white rounded-full shadow-organic-lg whatsapp-bounce hover:scale-110 transition-organic flex items-center justify-center group relative"
          aria-label="Chat on WhatsApp"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white" stroke="white" strokeWidth="0" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
          <div className="absolute -top-12 right-0 bg-text-primary text-white px-3 py-1 rounded-lg text-sm font-caption opacity-0 group-hover:opacity-100 transition-organic whitespace-nowrap">
            Chat on WhatsApp
          </div>
        </button>
      </div>
    </>
  );
};

export default FloatingActionButtons;